import React, { forwardRef, useImperativeHandle } from 'react';
import { Table } from '@ajaibid/components';

import Detail from './components/Detail';
import useColumns from './hooks/useColumns';
import useHistoryRegular from './hooks/useHistoryRegular';
import { styTable, styWrapper } from './style';

/**
 * @typedef {import('@services/api/stock/history/regular').HistoryRegular} HistoryRegular
 * @typedef {import('@ajaibid/components').TableProps<HistoryRegular>['getRowId']} GetRowId
 */

/**
 * @type {GetRowId}
 */
function getRowId(row, ix, parent) {
  return `${parent ? `${parent?.id}__` : ''}${row?.idx_trade_no || ix}`; // Real one
}

function renderRowExpand(row) {
  return <Detail item={row.original} />;
}

const StockHistoryRegular = forwardRef((_, ref) => {
  const { data, isInitialLoading, refetch, isRefetching, fetchNextPage, isFetchingNextPage } =
    useHistoryRegular();

  const columns = useColumns();

  useImperativeHandle(ref, () => ({
    // Allow the following functions & variables to be called from its parents
    refetchTable: refetch,
    isRefetching: isRefetching,
  }));

  return (
    <div className={styWrapper}>
      <Table
        className={styTable}
        data={data}
        columns={columns}
        options={{ isHeaderVisible: true, isRowExpandable: true }}
        fetchNext={fetchNextPage}
        getRowId={getRowId}
        isInitialLoading={isInitialLoading}
        isFetchingNext={isFetchingNextPage}
        renderRowExpand={renderRowExpand}
        emptyStateContent="Mulai bertransaksi dan lihat statusnya di sini."
      />
    </div>
  );
});

export default StockHistoryRegular;
